<template>
    <div
        class="input-table"
        v-if="loaded"
    >
        <div
            v-for="(item, index) in items"
            :class="[disable(item) ? 'input-table-shadow-disabled' : 'input-table-shadow']"
            :key="index + reloadCount"
        >
            <div class="d-flex row align-items-center">
                <div class="col-4 border-right">
                    <input class="pl-3" type="text" readonly :value="item.name" />
                </div>
                <div class="col border-right">
                  <core-money-input readonly="readonly" :key="item.key" :amount.sync="item.purchasePrice"></core-money-input>
                </div>
                <div class="col border-right">
                  <core-money-input v-on:update:amount="priceChanged(item)" :readonly="disable(item)" :amount.sync="item.salePrice"></core-money-input>
                </div>
                <div class="col border-right">
                  <core-number-input @inputChangedAmountTransport="inputChangedAmountTransport" :eventCode="amountTransport" :item="item" :readonly="disable(item)" :amount.sync="item.amount"></core-number-input>
                </div>
                <div class="col">
                  <core-money-input readonly :key="subTotal(item)" :amount="subTotal(item)"></core-money-input>
                </div>
            </div>
        </div>
    </div>
    <div v-else>
        <small class="ml-2 px-2 bg-danger text-white">{{ $t('reservation.details.transport.no-times') }}</small>
    </div>

</template>

<script>
import Reservation from '@/services/hatsApi/Reservation'

export default {
  props: {
    prices: {
      type: Array | Object,
      required: false
    },
    service: {
      type: Object,
      required: true
    },
    departureDate: {
      default: null,
      type: String,
      required: false
    },
    arrivalDate: {
      default: null,
      type: String,
      required: false
    },
    selectedTypes: {
      type: Array,
      required: false
    },
    outbound: {
      type: Number | Boolean,
      required: false,
      default: true
    },
    selectedClass: {
      type: String | Number,
      required: false
    },
    selectedRoomsAmount: {
      type: String | Number,
      required: false
    },
    dataIsFilling: {
      type: Boolean,
      required: false
    },
    travelers: {
      default: () => ([]),
      type: Array,
      required: false
    }
  },
  data () {
    return {
      items: [],
      amountTransport: 'AmountTransport',
      fromDate: this.arrivalDate,
      untilDate: this.departureDate,
      loaded: false,
      selectedAvailability: 0,
      reloadCount: 0
    }
  },
  created () {
    this.loadAvailableServices()
  },
  methods: {
    calculatedPurchasePrice (item) {
      let koeff = 1
      if (this.service && this.service.commission) {
        koeff = 1 - (this.service.commission / 100)
      }
      item.purchasePrice = parseInt(item.salePrice ? (item.salePrice * koeff/*  * item.amount */) : item.purchasePrice)
      return item.purchasePrice
    },
    async loadAvailableServices () {
      try {
        let filters = [
          {
            property: 'serviceIdParent',
            value: this.service.id
          },
          {
            property: 'date',
            value: this.arrivalDate
          },
          {
            property: 'outbound',
            value: Boolean(this.outbound)
          }
        ]
        const availableServices = await Reservation.getTransportTypes(filters)
        if (availableServices.data.success) {
          const response = availableServices.data.data
          this.setSelectedAmounts(response)
          this.items = response
          let isSelected = false
          this.items.forEach(item => {
            this.selectedTypes.forEach((type, index) => {
              if (parseInt(type.serviceId) === parseInt(item.id)) {
                this.$set(item, 'amount', type.amount)
              }
            })
            item.purchasePrice = this.calculatedPurchasePrice(item)
            item.key = 0
            if (this.dataIsFilling && !isSelected && ((parseInt(item.class) === 1 && parseInt(this.selectedClass) === 1) || (parseInt(item.class) === 2 && parseInt(this.selectedClass) === 2))) {
              let cnt = this.travelers.length ? this.travelers.length : 1
              this.$set(item, 'amount', cnt)
              this.inputChangedAmountTransport(cnt, item)
              isSelected = true
              this.reloadCount += 1
            }
          })
        }
      } catch (e) {
        console.log(e)
      }
      this.reloadCount += 1
      this.loaded = true
      this.$emit('occupancyLoaded', true)
    },
    // override amounts by the value from reservation (pre-set)
    setSelectedAmounts (response) {
      response.forEach((item) => {
        let salePrice = 0
        let purchasePrice = 0
        let amount = this.$_.sumBy(this.selectedTypes, (selected) => {
          if (selected.service && parseInt(selected.service.id) === parseInt(item.id)) {
            salePrice = selected.customPrice ? selected.customPrice : selected.salePrice
            purchasePrice = selected.purchasePrice
            return parseInt(selected.amount)
          } else {
            return 0
          }
        })
        if (amount > 0) {
          this.$set(item, 'salePrice', salePrice)
          this.$set(item, 'purchasePrice', purchasePrice)
        }
        this.$set(item, 'amount', amount)
      })
    },
    subTotal (transportType) {
      if (!this.prices || !this.prices.reservationLines) {
        return 0
      }

      const subTotalPrice = this.prices.reservationLines.find(price => price.serviceId === transportType.id)
      return subTotalPrice ? subTotalPrice.subTotalSalePrice : 0
    },
    disable (item) {
      return !item.salePrice
    },
    inputChangedAmountTransport (cnt, item) {
      const cloneItem = Object.assign({}, item)
      if (cnt) {
        cloneItem.amount = cnt
      }
      setTimeout(() => {
        item.purchasePrice = this.calculatedPurchasePrice(item)
        item.key++
        this.$emit('freeSaleAmountChanged', this.items, cloneItem)
      }, 100)
    },
    priceChanged (item) {
      setTimeout(() => {
        item.purchasePrice = this.calculatedPurchasePrice(item)
        item.key++
        this.$emit('freeSaleAmountChanged', this.items, item)
      }, 100)
    }
  },
  watch: {
    items: {
      handler (newVal) {
        this.$emit('freeSaleAmountChanged', newVal)
      },
      deep: true,
      immediate: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/reservation/details/FreeSaleTransportType.vue